import React, { FC, useEffect, useState } from "react";
import styles from "./page-wrapper.module.scss";
import { useCurrentUser } from "../../helpers/utils";
import { defaultSettings } from "../../defaultSettings";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import { Result, Space } from "antd";
import { AveliosButton } from "../common-layout/avelios-button";

export const PageAuth: FC = () => {
  const { formatMessage } = useIntl();
  const { currentUser, userLoading } = useCurrentUser();
  const { securedRoutes } = defaultSettings;
  const router = useRouter();

  const [loginRequired, setLoginRequired] = useState<boolean>(false);

  useEffect(() => {
    const baseRoute = router.route;
    if (!currentUser && !userLoading && securedRoutes.includes(baseRoute)) {
      setLoginRequired(true);
    } else {
      setLoginRequired(false);
    }
  }, [currentUser]);

  return (
    <div className={loginRequired ? styles.authWrapper : styles.signedIn}>
      <div className={styles.login}>
        <Result
          status="403"
          title={formatMessage({ id: "auth-required" })}
          subTitle={formatMessage({ id: "auth-required.description" })}
          extra={
            <Space>
              <AveliosButton
                type="default"
                onClick={() => router.push("/home")}
              >
                {formatMessage({ id: "not-found.back-home" })}
              </AveliosButton>
              <AveliosButton
                type="primary"
                onClick={() =>
                  router.push({
                    pathname: "/login",
                    query: {
                      destination: router.asPath,
                    },
                  })
                }
              >
                {formatMessage({ id: "action.login" })}
              </AveliosButton>
            </Space>
          }
        />
      </div>
    </div>
  );
};
